module.exports = __webpack_public_path__ + "img/SLP.92947595.svg";